export const useFormatDate = (datestring) => {
	const date = new Date(datestring)
	return `${date.getDate()}. ${date.getMonth()+1}. ${date.getFullYear()}`
}